import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button, Image } from '@outdoor-voices/ui';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import css from './ImageText.module.scss';
import newLineToBreakTag from '../../utils/strings/newLineToBreakTag';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var ImageText = function ImageText(_ref) {
  var cta = _ref.cta,
      description = _ref.description,
      image = _ref.image,
      title = _ref.title;
  var rootRef = useRef();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("header", {
      className: css.root,
      ref: rootRef,
      children: [image && /*#__PURE__*/_jsx("div", {
        className: css.image,
        children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
          alt: title,
          lazyload: false,
          sizes: [480, 600, 800, 1200, 1600]
        }))
      }), /*#__PURE__*/_jsxs("div", {
        className: css.text,
        children: [/*#__PURE__*/_jsxs("div", {
          children: [title && /*#__PURE__*/_jsx("h1", {
            className: css.title,
            dangerouslySetInnerHTML: {
              __html: newLineToBreakTag(title)
            }
          }), description && /*#__PURE__*/_jsx("h2", {
            className: css.subtitle,
            dangerouslySetInnerHTML: {
              __html: newLineToBreakTag(description)
            }
          })]
        }), cta && /*#__PURE__*/_jsx("div", {
          className: css.ctas,
          children: /*#__PURE__*/_jsx("div", {
            className: css.cta,
            children: /*#__PURE__*/_jsx(Button, {
              big: true,
              full: true,
              href: cta.href,
              children: cta.text
            })
          })
        })]
      })]
    })
  });
};

ImageText.defaultProps = {
  className: false,
  centerContent: false,
  cta: false,
  description: false,
  image: false,
  ratio4x1: false,
  textColor: '',
  title: false,
  subtitleUrl: false
};
ImageText.propTypes = {
  centerContent: PropTypes.bool,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  cta: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
    href: PropTypes.string,
    text: PropTypes.string,
    white: PropTypes.bool
  })]),
  description: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  subtitle: PropTypes.string.isRequired,
  image: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  ratio4x1: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape]),
  textColor: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  subtitleUrl: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};
export default ImageText;